import { IconButton, Paper, Slider, Tooltip, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import { MAX_ZOOM, MIN_ZOOM } from './flowGeometry';

// Bottom-left zoom toolbar: slider (25%-200%), +/- buttons and "Fit" button.
const ZoomControls = ({ zoom, onZoomTo, onFit }) => (
  <Paper
    elevation={3}
    onPointerDown={event => event.stopPropagation()}
    sx={{
      position: 'absolute',
      left: 16,
      bottom: 16,
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      px: 1.25,
      py: 0.5,
      borderRadius: 2,
      zIndex: 5,
    }}
  >
    <Tooltip title='Verkleinern'>
      <IconButton size='small' aria-label='Verkleinern' onClick={() => onZoomTo(zoom / 1.2)}>
        <RemoveIcon fontSize='small' />
      </IconButton>
    </Tooltip>
    <Slider
      size='small'
      aria-label='Zoomstufe'
      value={Math.round(zoom * 100)}
      min={Math.round(MIN_ZOOM * 100)}
      max={Math.round(MAX_ZOOM * 100)}
      onChange={(event, value) => onZoomTo(value / 100)}
      sx={{ width: 110 }}
    />
    <Tooltip title='Vergrößern'>
      <IconButton size='small' aria-label='Vergrößern' onClick={() => onZoomTo(zoom * 1.2)}>
        <AddIcon fontSize='small' />
      </IconButton>
    </Tooltip>
    <Typography variant='caption' sx={{ width: 42, textAlign: 'center' }}>
      {Math.round(zoom * 100)}%
    </Typography>
    <Tooltip title='Ansicht einpassen'>
      <IconButton size='small' aria-label='Ansicht einpassen' onClick={onFit}>
        <FitScreenIcon fontSize='small' />
      </IconButton>
    </Tooltip>
  </Paper>
);

export default ZoomControls;
